<div
  class="seech-avatar"
  [class.seech-avatar--clickable]="clickable"
  [class.seech-avatar--disabled]="disabled"
  [class.seech-avatar--loading]="loading"
  [class.seech-avatar--shadow]="shadow"
  [style.--avatar-size]="effectiveSize()"
  [style.--avatar-border-radius]="effectiveShape()"
  [style.--avatar-font-size]="effectiveFontSize()"
  [style.--avatar-border-width]="borderWidth"
  [style.--avatar-border-color]="borderColor"
  [style.--avatar-bg-color]="backgroundColorComputed()"
  [style.--avatar-text-color]="textColorComputed()"
  (click)="onClick()"
  [attr.role]="clickable ? 'button' : null"
  [attr.tabindex]="clickable && !disabled ? 0 : null"
  [attr.aria-label]="name ? 'Avatar for ' + name : 'Avatar'"
>
  <!-- Loading state -->
  <div *ngIf="loading" class="seech-avatar__loading">
    <div class="seech-avatar__spinner"></div>
  </div>

  <!-- Image state -->
  <ng-container *ngIf="!loading && imageUrl && showImage(); else fallback">
    <img
      [src]="imageUrl"
      [alt]="name || 'Avatar'"
      (error)="onImageError()"
      (load)="onImageLoad()"
      class="seech-avatar__image"
      [style.object-fit]="objectFit"
    />
  </ng-container>

  <!-- Fallback state (initials or placeholder) -->
  <ng-template #fallback>
    <div class="seech-avatar__fallback">
      <span class="seech-avatar__text">{{ displayText() }}</span>
    </div>
  </ng-template>

  <!-- Overlay Icon -->
  <div
    *ngIf="overlayIcon && !loading"
    class="seech-avatar__overlay"
    [ngClass]="overlayIconPositionClass()"
    [style.--overlay-icon-size]="overlayIconSizeValue()"
    [style.--overlay-container-size]="overlayContainerSizeValue()"
    [style.--overlay-offset-x]="overlayPositionOffsets().x"
    [style.--overlay-offset-y]="overlayPositionOffsets().y"
    [style.--overlay-icon-color]="overlayIconColor"
    [style.--overlay-icon-bg]="overlayIconBackground"
    (click)="onOverlayIconClick($event)"
    [attr.role]="'button'"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-label]="'Edit ' + (name || 'avatar')"
    [attr.aria-disabled]="disabled"
  >
    <i [sch-icon]="overlayIcon" class="seech-avatar__overlay-icon"></i>
  </div>
</div>